import './editor.scss';

import { registerPlugin } from '@wordpress/plugins';

import SettingsPanel from './editor/components/settings-panel';

registerPlugin( 'gwx-testimonial', {
    render() {
        return(<SettingsPanel />);
    }
} );
